import { cn } from '@exam-room/utils';
import { cva } from 'class-variance-authority';

import { CheckCircleOutlinedIcon, ErrorOutlineIcon, WarningRoundedIcon } from '../icons';

interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  message: string | JSX.Element;
  variant: 'error' | 'success' | 'info' | 'warning';
  hideIcon?: boolean;
}

const alertStyles = cva('flex items-center justify-start gap-3 rounded-lg px-4 py-3', {
  variants: {
    variant: {
      error: 'bg-red-50 text-danger',
      success: 'bg-green-50 text-success',
      info: 'bg-blue-50 text-info-900',
      warning: 'bg-warning-100 text-warning-900',
    },
  },
});

const iconStyles = cva('shrink-0', {
  variants: {
    variant: {
      error: 'text-danger',
      success: 'text-success',
      info: 'text-info',
      warning: 'text-warning',
    },
  },
});

const ALERT_ICONS = {
  error: ErrorOutlineIcon,
  success: CheckCircleOutlinedIcon,
  info: ErrorOutlineIcon,
  warning: WarningRoundedIcon,
};

function Alert({ message, variant, hideIcon, className }: AlertProps) {
  const IconComponent = ALERT_ICONS[variant];

  return (
    <div className={cn(alertStyles({ variant }), className)}>
      {hideIcon ? null : <IconComponent className={iconStyles({ variant })} />}
      <div className='text-md font-normal'>{message}</div>
    </div>
  );
}

export default Alert;
